import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import WorksheetGrid from 'components/worksheet/worksheet_grid';
import BannerNoticeIndex from 'components/banner_notice/banner_notice_index';
import { observable } from 'mobx';
import autobind from 'autobind-decorator';
import ExerciseIndex from 'components/exercise/exercise_index';
import { AppUI } from '@seedlang/state';

@observer
class VideoWorksheetIndex extends React.Component {

  @observable activeView;

  constructor(props) {
    super(props);
    this.activeView = AppUI.user.currentUserGroup?.showExerciseView ? 'exercises' : 'videos';
  }

  @autobind onToggleExerciseView() {
    if (this.activeView === 'videos') {
      this.activeView = 'exercises';
    } else {
      this.activeView = 'videos';
    }
    AppUI.userGroupStore.update({
      ids: { userGroupId: AppUI.user.currentUserGroup?.id },
      data: { showExerciseView: this.activeView === 'exercises' },
    });
  }

  render() {
    return (
      <>
        <BannerNoticeIndex
          route='videos.index'
        />
        {
          this.activeView === 'videos' &&
            <WorksheetGrid
              showFilters
              useGridLayout={false}
              defaultWorksheetFilter={{youtube_url: true, podcast_episode_id: false}}
              activeView={this.activeView}
              onToggleExerciseView={this.onToggleExerciseView}
              {...this.props}
            />
        }
        {
          this.activeView === 'exercises' &&
            <ExerciseIndex
              activeView={this.activeView}
              onToggleExerciseView={this.onToggleExerciseView}
              {...this.props}
            />
        }
      </>
    );
  }
}

export default ErrorBoundary(VideoWorksheetIndex);
